import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { saveReferralCode } from "../utils/referralSession";
import { apiFetch } from "../utils/apiClient";

export default function JoinReferral() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const recordReferralClick = async () => {
      if (!code) return;
      try {
        await apiFetch("/users/referral/click", {
          method: "POST",
          data: { referralCode: code },
        });
      } catch (error) {
        // Non-blocking metric; ignore failures
      }
    };

    if (code) {
      saveReferralCode(code);
      recordReferralClick();
    }

    const timer = setTimeout(() => {
      if (!cancelled) {
        navigate("/signup", {
          replace: true,
          state: { referralLanding: true },
        });
      }
    }, 1000);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [code, navigate]);

  return (
    <section className="flex min-h-screen w-full items-center justify-center bg-black px-6 text-white">
      <div className="rounded-3xl border border-white/10 bg-gradient-to-br from-[#1B1033] via-[#120C24] to-[#08070F] px-8 py-10 text-center shadow-[0_40px_120px_rgba(0,0,0,0.6)]">
        <p className="text-sm uppercase tracking-[0.4em] text-white/50">Referral detected</p>
        <h1 className="mt-4 text-3xl font-semibold">Preparing your signup</h1>
        <p className="mt-2 max-w-md text-sm text-white/70">
          We saved your referral so you can unlock discounted pricing. Redirecting you to
          create your SynergyCoin account…
        </p>
      </div>
    </section>
  );
}
